import React from 'react';
import {useTranslation, Trans} from 'react-i18next';
import titleErrorIcon from '../../../assets/error-icon.svg';
import wrongIcon from '../../../assets/something-wrong-icon.png';
import {Content, Description, Title, TitleIcon} from '../styled';

function Error() {
  const {t} = useTranslation();

  return (
    <Content>
      <img src={wrongIcon} alt="wrongIcon" width={78} height={78} />
      <Title>
        <TitleIcon src={titleErrorIcon} alt="titleErrorIcon" width={32} height={32} />
        {t('connection_issue')}
      </Title>
      <Description>
        <Trans i18nKey="connection_issue_description">
          The door couldn't be opened at the moment, please go back to the link and try
          again. <br />
          <br /> If the error persist please contact your host for further instructions.
        </Trans>
      </Description>
    </Content>
  );
}

export {Error};
